import { useRef } from "react";
import testimonialImage from "../../assets/bgimg.jpg";
import srinivasaImage from "../../assets/tesimonialImg1.jpeg";
import "./TestimonialsComponent.css";

const TestimonialsPage = () => {
  const hyderabadRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      text: "Firstly, I would like to thank CREDTECH for inviting me and for organizing such a wonderful event that brought together some of the senior-most leaders of the industry. Engaging with industry leaders and exchanging perspectives offered valuable insights and a vision for the evolving GCC landscape in India. I’ll be more than happy to join such enriching events across India to share experiences and learnings with the industry.",
      name: "Mr. Srinivasa Prasad Vemuru",
      designation: "Senior Director - Facilities, India at OpenText",
      image: srinivasaImage,
    },
    {
      id: 2,
      text: "Thank you to CREDTECH and the wonderful people at the CREDTECH Knowledge Platform – Hyderabad Edition for a day of learning and sharing.",
      name: "Gokhana",
    },
    {
      id: 3,
      text: "Our CEO, Ankur Marda, enjoyed the warm Hyderabad welcome and was truly energised by the panel discussion with other distinguished participants on Next Gen Workspaces.",
      name: "Gokhana",
    },
    {
      id: 4,
      text: "Thank you, CREDTECH, for highlighting impactful leadership and curating a platform that fosters forward-thinking dialogue in commercial real estate and procurement.",
      name: "Encore",
    },
    {
      id: 5,
      text: "CREDTECH 2025 – Pune was an incredible event at the Ritz Carlton, a great platform for networking, knowledge sharing, and interacting with industry veterans. Grateful to be part of such engaging conversations and a vibrant community!",
      name: "Yogesh Sharma, Coditas",
    },
    {
      id: 6,
      text: "Just wrapped up an incredible event hosted by CREDTECH — an inspiring lineup of speakers, insightful discussions on EVs, GCC growth, and Vision 2030, and the chance to interact with industry veterans. Grateful for the engaging conversations, vibrant community, and warm invitation from Sunanda Jaiprakash.",
      name: "Jyothi Patil",
    },
    {
      id: 7,
      text: "Proud to be part of CREDTECH Pune 2025, where our MD, Alok Kumar, shared insights on the evolving GCC landscape and India's next growth story driven by startups and SMEs. Kudos to CREDTECH and Sunanda Jaiprakash for curating such a meaningful platform that fosters impactful dialogue.",
      name: "SRKay Consulting Group",
    },
  ];

  const videos = [
    {
      id: 1,
      url: "https://youtube.com/shorts/Dq7unkcwcQQ?si=CvuF7bnaQQE7_CMZ",
    },
    {
      id: 2,
      url: "https://youtube.com/shorts/yzBedBRG7UQ?si=OA31PRhVsQh2sr1Q",
    },
    {
      id: 3,
      url: "https://youtube.com/shorts/ly-cCFbUaAo?si=0VpleQAutamvEhDn",
    },
    {
      id: 4,
      url: "https://youtube.com/shorts/K1-EaRdKMZ0?si=0Mq1P7W5LUzdQvWc",
    },
  ];

  const getYouTubeEmbedUrl = (url) => {
    if (url.includes("embed/")) return url;

    let videoId = "";

    if (url.includes("youtube.com/watch")) {
      const urlParams = new URLSearchParams(new URL(url).search);
      videoId = urlParams.get("v");
    } else if (url.includes("youtube.com/shorts/")) {
      videoId = url.split("shorts/")[1]?.split("?")[0];
    } else if (url.includes("youtu.be/")) {
      videoId = url.split("youtu.be/")[1]?.split("?")[0];
    }

    return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
  };

  return (
    <div className="testimonials-page">
      <div
        className="testimonials-hero"
        style={{ backgroundImage: `url(${testimonialImage})` }}
      >
        <div className="hero-overlay">
          <h1 className="testimonials-title">TESTIMONIALS</h1>
        </div>
      </div>

      <div className="testimonials-container">
        <div className="gallery-wrapper">
          <div className="gallery-scroll-container" ref={hyderabadRef}>
            {videos.map((video) => (
              <div key={video.id} className="gallery-item">
                <div className="video-container">
                  <iframe
                    className="gallery-video"
                    src={getYouTubeEmbedUrl(video.url)}
                    title="Testimonial Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            ))}
          </div>
          <div className="scroll-hint">← Swipe to see more →</div>
        </div>
      </div>

      <div className="testimonials-container">
        <div className="testimonials-header">
          <h2 className="section-title">
            Reflections From the Visionaries of Our Community
          </h2>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-content">
                {testimonial.image && (
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="testimonial-image"
                  />
                )}
                <div className="testimonial-text-container">
                  <p className="testimonial-text">"{testimonial.text}"</p>
                </div>
                <div className="testimonial-author">
                  <p className="author-info">- {testimonial.name}</p>
                  {testimonial.designation && (
                    <p className="author-info">{testimonial.designation}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsPage;
